import { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { StaticPageLayout } from '../layouts/StaticPageLayout'
import analyticsService from '../services/analytics/analytics'

const NotFound = () => {
  const location = useLocation()

  useEffect(() => {
    // Track 404 page view with the attempted URL
    analyticsService.trackEvent('404_page_view', {
      attempted_url: location.pathname + location.search,
      referrer: document.referrer || 'direct',
    })
  }, [location])

  return (
    <StaticPageLayout title="">
      <div className="flex flex-col items-center justify-center text-white px-4 py-16">
        {/* Large 404 Text */}
        <h1 className="text-9xl font-bold text-gray-600 mb-4">404</h1>

        {/* Error Message */}
        <h2 className="text-3xl font-semibold mb-2">Page Not Found</h2>
        <p className="text-gray-400 text-center max-w-md mb-8">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>

        {/* Action Button */}
        <Link
          to="/"
          className="px-6 py-3 bg-dark-secondary border border-dark-border rounded-lg hover:bg-dark-tertiary transition-colors text-center"
        >
          Go Home
        </Link>

        {/* Additional Help Text */}
        <div className="mt-12 text-sm text-gray-500 text-center">
          <p>If you believe this is an error, please contact support.</p>
        </div>
      </div>
    </StaticPageLayout>
  )
}

export default NotFound
